
export const messages =
   {    
        "M0000.wav":"ההודעה שתושמע ראשונה בשלוחה",
        "M0001.wav":"הודעה עם הגבלת זמן",
        "M0002.wav":"הודעה שעל כל מקש חוזר במודול play_and_return",
        "M1000.wav":"תפריט. אנא הקישו את מספר השלוחה",
        "M1001.wav":"המקש שֶהוֹקַש שגוי",
        "M1002.wav":"לא הוקשה בחירה",
        "M1003.wav":"אורך",
        "M1004.wav":"דקות",
        "M1005.wav":"סוף הודעות",
        "M1006.wav":"beep",
        "M1007.wav":"השידור חי עדיין לא החל. להמתנה לַשידור הַקִישוּ 1, להאזנה לשידורים קודמים הַקִישוּ 2",
        "M1008.wav":"השידור יחל מיד עם כניסתו של המנהל.",
        "M1009.wav":"לשמיעת ההקלטה הקישו 1. לאישור ההקלטה הקישו 2. להקלטה מחודשת 3.לביטול וחזרה הקישו 4",
        "M1010.wav":"הֶקְלַטֶתֶם בהצלחה את קובץ מספר",
        "M1011.wav":"להקלטה נוספת הַקִישוּ 1. לְסיום הַקִישוּ 2 או הַמתינו.",
        "M1012.wav":"אנא הקליטו את הודעתכם לאחר הצליל. בסיום הַקישו סולמית",
        "M1013.wav":"עד היום צברת",
        "M1014.wav":"נקודות",
        "M1015.wav":"מספר הטלפון שלכם אינו מזוהה",
        "M1016.wav":"המספר האישי שלכם אינו מזוהה",
        "M1017.wav":"קיבלת",
        "M1018.wav":"אין נתונים על השמעה אחרונה",
        "M1019.wav":"הנך בדקה",
        "M1020.wav":"מתוך",
        "M1021.wav":"שלוחה",
        "M1022.wav":"האזנה",
        "M1023.wav":"לא ניתן לצרף את טלפון",
        "M1024.wav":"הוספתם בהצלחה לרשימת התפוצה את טלפון מספר",
        "M1025.wav":"לא ניתן להסיר את טלפון",
        "M1026.wav":"שלום ותודה",
        "M1027.wav":"הסרת מספר. הנכם מבקשים להסיר את טלפון מספר",
        "M1028.wav":"האם הנכם בטוחים? לאישור ההסרה הַקישו1 , לֶביטול הקישו 2, או נתקו את השיחה.",
        "M1029.wav":"הסרת מספר הטלפון בוטלה",
        "M1030.wav":"הסרתם בהצלחה מרשימת התפוצה את טלפון מספר",
        "M1031.wav":"להוראות הפעלה הקישו1. להשארת הודעה למנהל המערכת הקישו2. לחזרה למיקום האחרון אליו הֶאֵזַנְתֶם הקישו3. לשמיעת כל התכנים החדשים במערכת הקישו 4",
        "M1032.wav":"הוראות הפעלה בכל שלב ניתן להקיש סולמית ולחזור שְלַב אחד אחורה או כוכבית לחזרה לתחילת המערכת. בעת שמיעת קובץ לחזרה 10 שניות אחורה הקישו 1, קדימה 3. חזרה 5 דקות אחורה הקישו 4, קדימה 6.להפסקה זמנית הקישו 5, ושוב 5 להמשך האזנה.להשמעה קודמת הקישו 2, להשמעה הבאה הקישו 8לחזרה להתחלה הקישו 4 ועוד 4 כפי הצורך.להפעלת קובץ אקראי הקישו 9לשמיעת פרטי ההודעה ואפשרויות האזנה הקישו0.חזרה לתפריט קודם הַקישו סולמית. חזרה לתחילת המערכת הַקישו כוכבית",
        "M1033.wav":"לגישה אנא הכנס כמנהל",
        "M1034.wav":"לאישור הקישו 1, להקשה מחודשת 2.",
        "M1035.wav":"לא הקּשתּם את מינימום הספרות הנדרשות",
        "M1036.wav":"אנא הקישו את מספר הקובץ וסולמית לֶסיום",
        "M1037.wav":"הכותרת הוקלטה בהצלחה",
        "M1038.wav":"אנא הקליטו את כותרת הקובץ לאחר הצליל ובסיום הקישו סולמית",
        "M1039.wav":"אנא הקישו את מספר השלוחה לניתוב וסולמית",
        "M1040.wav":"ליציאה הקישו כוכבית",
        "M1041.wav":"המענה סַגוּר כעת, אנא נסו שוב בשעות הפעילות",
        "M1042.wav":"שלוחה זו אינה מוגדרת במערכת",
        "M1043.wav":"יתרת יחידות נמוכה לביצוע השיחה",
        "M1044.wav":"אנא נסו שנית ממספר טלפון מזוהה",
        "M1045.wav":"ברוכים הבאים למערכת ההזמנות של המערכות החינמיות, לקבלת מערכת הקישו 1",
        "M1046.wav":"ניתן לפתוח מערכת אחת בשבוע, אנא נסו שוב בשבוע הבא",
        "M1047.wav":"אנא בחרו סיסמת ניהול ולסיום הקישו סולמית",
        "M1048.wav":"לצערינו אין כרגע מספרי טלפון להקצאה, אנא נסו שוב במועד מאוחר יותר",
        "M1049.wav":"מזל טוב - פתחתם מערכת חינמית משלכם, מספר הטלפון של המערכת הוא",
        "M1050.wav":"הטלפון של מנהל המערכת",
        "M1051.wav":"סיסמת הניהול היא",
        "M1052.wav":"לשמיעה מחודשת של מספר המערכת הקישו 1. לֶסיום הקישו 2",
        "M1053.wav":"אנא אֶמׂר במספר מילים עבור מה מיועדת המערכת",
        "M1054.wav":"אנא הקליטו את שמכם הפרטי אות אחר אות. לדוגמא לַשֶם משה אִמרו משה, מם שין הֶי. בסיום הַקישו סולמית",
        "M1055.wav":"אנא הקליטו את שם המשפחה שלכם אות אחר אות. לדוגמא למשפחת כהן אִמרו כהן, כף הֶי נון. בסיום הַקישו סולמית",
        "M1056.wav":"להלן הפרטים שנקלטו",
        "M1057.wav":"לאישור הקישו 1 לשמיעה חוזרת 2 להקלטה מחדש הקישו 3",
        "M1058.wav":"סיסמה קצַרה מידי",
        "M1059.wav":"במידה וברצונכם להכניס טלפון נוסף בתור מנהל מערכת, הַקישו את מספרו וסולמית לֶסיום. לֶדילוג הַקישו סולמית או הַמתינו.",
        "M1060.wav":"אנא השאירו הודעתכם לאחר הִשַמע הצליל. לֶסיום נתקו את השיחה או הַקישו סולמית",
        "M1061.wav":"לשמיעת ההודעה הקישו 1, לֶאישור הקישו 2, להקלטה מחודשת 3, לביטול וחזרה הקישו 4.",
        "M1062.wav":"מיד תועברו להקלטת הברכה, לפני בקשת הברכה מקבלים החלטה טובה בתורה מצוות ומעשים טובים ומכריזים יחי.. אנא השאירו את בקשת הברכה שמכם שם אמכם. בסיום ההקלטה הקישו סולמית",
        "M1063.wav":"לאישור ושליחת בקשת הברכה, הקישו 1 לשמיעת בקשת הברכה 2 להקלטה מחודשת של בקשת הברה 3",
        "M1064.wav":"קיבלתם תשובה מהרבי שליטא מלך המשיח באמצעות האיגרות קודש בכרך",
        "M1065.wav":"עמוד",
        "M1066.wav":"ועמוד",
        "M1067.wav":"לשמיעה חוזרת של מיקום התשובה הקש 1;לקבלת העתק ממכתב התשובה מיידית לתיבת הדואר האלקטרוני שלכם הקישו 2.;לקבלת העתק ממכתב התשובה בדואר רגיל לביתכם הקישו 3.;לחזרה לתפריט הראשי הקישו *",
        "M1068.wav":"על מנת שנוכל לשלוח את הְעֶתֶק התשובה לביתכם, אנא הקליטו את הפרטים לְמשלוח -  שלב אחר שלב",
        "M1069.wav":"אנא הקליטו את מספר הבית, ובסיום הַקישו סולמית",
        "M1070.wav":"אנא הקליטו את מספר הדירה, ובסיום הַקישו סולמית",
        "M1071.wav":"אנא הקליטו את שם העיר אות אחר אות. לדוגמא לעיר חיפה אִמרו חיפה, חת יוד פְּי הֶי. בסיום הַקישו סולמית",
        "M1072.wav":"להלן הפרטים למשלוח הדואר",
        "M1073.wav":"אנא הקישו על מקשי הטלפון, את מספר מיקוד הדואר בכתובת שציינתם, בסיום הַקישו סולמית",
        "M1074.wav":"אנא הקישו על מקשי הטלפון, מספר טלפון בו במידת הצורך יהיה ניתן ליצור אתכם קשר, בסיום הַקישו סולמית",
        "M1075.wav":"תודה רבה, בקשתכם למשלוח הְעֶתֶק התשובה בדואר, התקבלה בהצלחה",
        "M1076.wav":"מספר הפּנִיַה הוא",
        "M1077.wav":"לסיום ומַעַבַר לתפריט הראשי, הקישו 1.לשמיעת מספר הפּנִיַה שנית, לצורך בירור עתידי, הקישו 2",
        "M1078.wav":"לְאישור הקישו 1. להקלטה מחודשת של הפרטים הקישו 2",
        "M1079.wav":"אנא הקליטו את שם הרחוב אות אחר אות, לדוגמא לרחוב חבצלת אִמְרוּ: חבצלת, ח,ב,צ,ל,ת. בסיום הַקישו סולמית.",
        "M1080.wav":"שגיאה",
        "M1081.wav":"הפרק אותו קיבלת לקריאה הינו פרק (מיועד לחלוקת פרק אחד או שניים)",
        "M1082.wav":"וכן את פרק (מיועד לחלוקה של  2 פרקים) (עד פרק בקריאה אישית)",
        "M1083.wav":"תזכה למצוות (וכן את כל ההודעות לאחרי השמעת הפרקים)",
        "M1084.wav":"הפרקים אותם קיבלתם לקריאה הינם פרקים (מיועד לחלוקה של מעל 2 פרקים)",
        "M1085.wav":"עד פרק (מיועד לחלוקה של מעל 2 פרקים)",
        "M1086.wav":"הפרשה אותה קיבלת לקריאה הינה פרשת",
        "M1087.wav":"עד פרשת / וכן את פרשת",
        "M1088.wav":"עד פרשת",
        "M1089.wav":"תפריט בחירה שְלַב...",
        "M1090.wav":"אנא הקישו את בחירתכם ב...",
        "M1091.wav":"סְפַרוֹת",
        "M1092.wav":"לפרשת",
        "M1093.wav":"תזכורת ספירת העומר",
        "M1094.wav":"הודעה לאחר תזכורת ספירת העומר - ברירת מחדל 'ניתן ללמוד את השיעור היומי מפי הרב יוסף יצחק כץ'",
        "M1095.wav":"שגיאת ניהול, לא הוגדר סוג זיהוי",
        "M1096.wav":"להקלטה אנא הקישו את מספר התיקייה וסולמית לסיום.להקלטה בתיקייה הזמנית הקישו סולמית.להקלטה בתתי תיקיות הקישו את הכתובת המלאה, כאשר בין תיקייה לתיקייה הקישו כוכבית. בסיום הכתובת המלאה הקישו סולמית.",
        "M1097.wav":"אין הרשאה להקלטה בתיקיה זו",
        "M1098.wav":"כבר קיבלתם ניקוד על ערך זה",
        "M1099.wav":"אין הודעה להשמעה",
        "M1100.wav":"נא הקש את הסיסמה ובסיום הקש סולמית",
        "M1101.wav":"סיסמה שגויה",
        "M1102.wav":"אין לכם הרשאת גישה לתיקייה זו",
        "M1103.wav":"אנא הקישו את המספר האישי וסולמית לְסיום",
        "M1104.wav":"המספר האישי שֶ הוּקַש שגוי",
        "M1105.wav":"התחברתם בהצלחה",
        "M1106.wav":"שלום לך מספר אישי",
        "M1107.wav":"ניכר כי הנכם משתמשים חדשים במערכת",
        "M1108.wav":"אנא אמרו את שמכם ושם משפחתכם לאחר השמע הצליל",
        "M1109.wav":"אם אתם מרוצים מההקלטה הקישו 1 להקלטה מחודשת 2",
        "M1110.wav":"הקלטת השם נקלטה בהצלחה",
        "M1111.wav":"שלום ל..",
        "M1112.wav":"תזכורת ספירת העומר",
        "M1113.wav":"הודעה לאחר תזכורת ספירת העומר - ברירת מחדל ניתן ללמוד את השיעור היומי מפי הרב יוסף יצחק כץ",
        "M1114.wav":"שלוחה זו סגורה כעת, אנא נסו שוב בשעות הפעילות",
        "M1200.wav":"ענית בהצלחה",
        "M1201.wav":"עדכון המשימה התקבל בהצלחה",
        "M1202.wav":"תשובה נכונה תזכה אתכן עד",
        "M1203.wav":"ברוכים הבאים למשחק הטריוויה",
        "M1204.wav":"ועכשיו נשאל אתכם שאלה על הקטע שלמדתם",
        "M1205.wav":"נקודות",
        "M1206.wav":"הנך מועבר לשאלה הבאה",
        "M1207.wav":"השאלה היא",
        "M1208.wav":"אנא הקישו את מספר התשובה הנכונה",
        "M1209.wav":"שעון מתקטק",
        "M1210.wav":"תשובתך שגויה",
        "M1211.wav":"תשובה ראשונה",
        "M1212.wav":"תשובה שניה",
        "M1213.wav":"תשובה שלישית",
        "M1214.wav":"תשובה רביעית",
        "M1215.wav":"אנא נסה שנית",
        "M1216.wav":"התשובה הנכונה היא",
        "M1217.wav":"נכון או לא נכון",
        "M1218.wav":"לנכון הקישו 1 ללא נכון הקישו 0",
        "M1219.wav":"התשובה היא",
        "M1220.wav":"לא נכון",
        "M1221.wav":"נכון",
        "M1222.wav":"סך הניקוד שברשותך הוא",
        "M1223.wav":"קיבלת",
        "M1224.wav":"בחירה לא חוקית",
        "M1225.wav":"השיא שלכם בטרוויה הוא",
        "M1226.wav":"הנכם מתחילים משחק חדש",
        "M1227.wav":"סך הניקוד במשחק החדש הוא",
        "M1228.wav":"סיימתם בהצלחה את כל השאלות בטריוויה",
        "M1229.wav":"סך הניקוד שצברתם במהלך המשחק הוא",
        "M1230.wav":"כל הכבוד",
        "M1231.wav":"להפעלה מחודשת של הטריוויה הקישו 1 לחזרה לתפריט הראשי הקישו 2",
        "M1232.wav":"השיא החדש שלך הוא",
        "M1240.wav":"אולי בפעם אחרת",
        "M1241.wav":"אופס, טעות",
        "M1242.wav":"הפעם שגית",
        "M1243.wav":"לא נורא",
        "M1244.wav":"ממש... לא!",
        "M1245.wav":"מענין, אבל זה לא זה",
        "M1246.wav":"נסה שוב",
        "M1247.wav":"שווה לקרוא את החומר פעם נוספת",
        "M1250.wav":"אדיר",
        "M1251.wav":"איזו בקיאות",
        "M1252.wav":"אין כמוך",
        "M1253.wav":"אתה ממש גאון",
        "M1254.wav":"אתה פשוט עשר",
        "M1255.wav":"וואו!! אתה מקסים",
        "M1256.wav":"חכם כמוך לא רואים כל יום",
        "M1257.wav":"יפה מאוד",
        "M1258.wav":"יש במה להתגאות",
        "M1259.wav":"יש לך ראש פיצוץ",
        "M1260.wav":"כל הכבוד",
        "M1261.wav":"לא יאומן!",
        "M1262.wav":"מדהים",
        "M1263.wav":"מיוחד",
        "M1264.wav":"נפלא",
        "M1265.wav":"תמיד אמרו עליך שאתה ילד מחונן",
        "M1266.wav":"תמשיך כך",
        "M1270.wav":"הנך מועבר להקלטת שאלה מספר",
        "M1271.wav":"אנא הקליטו את השאלה לאחר השמע הצליל, לסיום הקישו סולמית",
        "M1272.wav":"אנא הקליטו את התשובה הנכונה ובסיום הקישו סולמית",
        "M1273.wav":"אנא הקליטו מסיח ראשון ובסיום הקישו סולמית",
        "M1274.wav":"אנא הקליטו מסיח שני ובסיום הקישו סולמית",
        "M1275.wav":"אנא הקליטו מסיח שלישי ובסיום הקישו סולמית",
        "M1277.wav":"אם ברצונכם בהקלטת מסיח שלישי הקישו 1להקלטת שאלה נוספת הקישו 2לחזרה לתפריט הראשי הקישו 3",
        "M1278.wav":"להקלטת שאלה נוספת הקישו 1לחזרה לתפריט הראשי הקישו 2",
        "M1279.wav":"להקלטת שאלה טריוויה אמריקאיתהקישו 1להקלטת שאלת נכון או לא נכון הקישו 2",
        "M1280.wav":"להקלטת שאלה שהתשובה עליה נכון  הקישו 1להקלטת שאלה שהתשובה עליה לא נכון הקישו 2",
        "M1281.wav":"השאלה הוקלטה בהצלחה",
        "M1282.wav":"התשובה הנכונה הוקלטה בהצלחה",
        "M1283.wav":"מסיח ראשון הוקלט בהצלחה",
        "M1284.wav":"מסיח שני הוקלט בהצלחה",
        "M1285.wav":"מסיח שלישי הוקלט בהצלחה",
        "M1290.wav":"להקלטת שאלה חדשה הקישו 1לעריכת שאלה קיימת הקישו 2",
        "M1301.wav":"בשלוחה זו צברת",
        "M1302.wav":"אי צבירת נקודות נוספות עדיין בתוקף",
        "M1303.wav":"אי צבירת נקודות נוספות בתיקיה זו עדיין בתוקף",
        "M1304.wav":"על ערך זה צברת",
        "M1305.wav":"ההודעה קצרה מידי",
        "M1306.wav":"ההודעה מבוטלת",
        "M1307.wav":"תגובות",
        "M1308.wav":"סוף תגובות",
        "M1309.wav":"אין תגובות להשמעה",
        "M1310.wav":"לשמיעת התגובות הקישו 1להמשך הקישו 2 או המתינו",
        "M1311.wav":"אנא הקש את מספר מערכת הלקוח עבורו להוציא את החשבונית",
        "M1312.wav":"אין ארועים",
        "M1313.wav":"אירועים להיום",
        "M1314.wav":"אירועים ליום",
        "M1316.wav":"טסט שמוליק טסט 2"
   }